import { createAPI } from "../apisServer";
import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("cobranca");

const reqFiscalConfig = {
	/**
	 * Configuracao fiscal da empresa do token. Um registro por empresa.
	 * O certificado nunca vem aqui - so os dados lidos dele.
	 */
	get: async function () {
		return apiServer
			.get("cobranca/v1/empresa-fiscal-config", {
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	save: async function (body) {
		return apiServer
			.post("cobranca/v1/empresa-fiscal-config", body, {
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	/**
	 * O .pfx vai em base64 e fica so no banco. O servidor abre o arquivo,
	 * confere validade e tipo, e devolve o que leu dele.
	 *
	 * CNPJ diferente do cadastro volta 409 com a divergencia - so grava
	 * quando reenviado com confirmar = true.
	 */
	uploadCertificado: async function (arquivo, senha, confirmar = false) {
		return apiServer
			.post(
				"cobranca/v1/empresa-fiscal-config/certificado",
				{ arquivo, senha, confirmar },
				{ headers: { banco: banco } },
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqFiscalConfig;
